export const BASE_URL = 'https://wordpress-react.local/';
export const loginUrl = 'http://192.168.1.106/wp/wp-react-login.php';
export const API_URL = 'http://wordpress-react.local/wp-json/';